// @ts-check
import React from "react"
import DropdownCategoryFilter from "../../../../../components/compounds/DropdownCategoryFilter.compound"
import InputPlaceholderChipTemplate from "../../../../../components/molecules/InputPlaceholderChipTemplate.molecule"

export default function CategoryChipDropdown({
  value,
  onChange,
  label = "Elige una categoría",
  placeholder = "Elige una categoría",
  name = "categoryGroup",
  options,
  optionValue,
  optionLabel = "categoryTitle",
  error,
  dropdownRef,
  disabled,
  dropdownInputProps,
  highlighted,
  loading,
}) {
  optionValue =
    options?.[0]?.specialCategoryID ? "specialCategoryID" : "categoryID"
  options = options?.map((o) => ({
    ...o,
    categoryFull: o?.categoryGroup + o?.categoryTitle + o?.categorySubtitle,
  }))
  optionLabel = "categoryFull"
  if (options) {
    if (options?.[0]?.specialCategoryID) {
      options = options?.sort((a, b) =>
        a?.categoryTitle?.localeCompare(b?.categoryGroup)
      )
    } else {
      options = options?.sort((a, b) =>
        a?.categoryTitle?.localeCompare(b?.categoryTitle)
      )
    }
  }

  const getCurrentOption = (value, key) => {
    return options?.find((o) => o?.[key || optionValue] === value)
  }

  const selectedCategory =
    value ?
      getCurrentOption(value)?.categoryTitle ||
      getCurrentOption(value)?.categoryGroup
    : false

  const displayedCategory =
    value ?
      getCurrentOption(value)?.categoryTitle ||
      getCurrentOption(value)?.categoryGroup
    : label

  return (
    <div className={`dropdown-category-filter`}>
      <DropdownCategoryFilter
        resetFilterOnHide={true}
        ref={dropdownRef}
        value={value}
        onChange={onChange}
        name={name}
        options={options}
        optionValue={optionValue}
        optionLabel={optionLabel}
        error={error}
        placeholder={placeholder}
        dropdownInputProps={dropdownInputProps}
        loading={loading}
      />
      <InputPlaceholderChipTemplate
        highlighted={highlighted}
        error={error}
        disabled={disabled}
        selected={selectedCategory}
        template={
          <span
            className={`text-overflow-ellipsis white-space-nowrap overflow-hidden max-w-12rem`}
          >
            {displayedCategory}{" "}
            {error ?
              <i
                className="pi pi-exclamation-triangle"
                data-pr-tooltip="Este es un campo requerido"
                data-pr-position="bottom"
              />
            : null}
          </span>
        }
        onClick={() => {
          dropdownRef.current?.show()
        }}
      />
    </div>
  )
}
